import { Routes } from '@angular/router';

import { applicationRoutes } from './app/application.routes';
import { mpsCoreRoutes } from './mps/routes/mps-core.routes';

// Front public : on n'inclut PAS les routes d'authentification MPS (login/logout).
// Seules les routes applicatives publiques + les routes core du bootstrap sont exposées.
export const globalRoutes: Routes = [
  ...applicationRoutes,
  ...mpsCoreRoutes,
  { path: '**', redirectTo: '', pathMatch: 'full' },
];
